import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import userBottomImg from "../../src/asset/images/partner-portal/person-images/person-with-mobile.png";
import HeaderPartner from "./HeaderPartner";
import UpHand from "../asset/images/revamp-images/finger.svg";
import DocumentMenually from "../asset/images/revamp-images/manualDoc.svg";
import Digilocker from "../asset/images/revamp-images/digilocker.svg";
import clock from "../asset/images/revamp-images/clock.svg";
import manualClock from "../asset/images/revamp-images/manualClock.svg";
import PageProgressBarPartner from "./PageProgressBarPartner";
import checkIcon from "../asset/images/partner-portal/blue-tick.svg";
import { Link, useNavigate } from "react-router-dom";
import { Partner_Portal } from "../Configuration/API_URL";
import { toast } from "react-toastify";
import axios from "axios";
import { decryptData, encryptData } from "../CommonMethods/CommonMethods";

import previosPageArrow from "../asset/images/revamp-images/previousPageBtn.svg";
import FormFooterPartner from "./FormFooterPartner";
import sheild from "../asset/images/revamp-images/shieldImg.svg";
import PageSideBar from "./PageSideBar";
import DigiDocumentList from "./DigiDocumentList";
import { InitiateDigio } from "../../src/digio/digio.ts";

const DocumentsUploadPartner = () => {
  const partnerToken = localStorage.getItem("partner_signup_token");
  const mobile = localStorage.getItem("Mobile");
  const incompletePan = localStorage?.getItem("incompletePan")
  const incompleteAddress = localStorage?.getItem("incompleteAddress")
  const docList = localStorage.getItem("documentList");
  const docListManual = localStorage.getItem("documentListManual");
  const navigate = useNavigate();
  const [manualDoc, setManualDoc] = useState(false);
  const [digiFlow, setDigiFlow] = useState(false);
  const [digioStatus, setDigioStatus] = useState(false);
  const [addressSection, setAddressSection] = useState(false);
  const [digiVal, setDigiVal] = useState(false);
  const docSection = localStorage.getItem("docSection");
  const [partnerData, setPartnerData] = useState("")

  if (partnerToken == null) {
    window.location.replace("/partner");
  }

  useEffect(() => {
    // This code will run after the component has been mounted
    let scriptElement = document.createElement('script');  // Create a new script element
    scriptElement.src = 'Digio.js';  // Load DigioApp.js for the /selfie path
    document.body.appendChild(scriptElement);  // Or append to <head>
    return () => {
      document.body.removeChild(scriptElement);
    };
  }, []);

  const handleDocList = (type) => {
    if (type === "digilocker") {
      localStorage.removeItem("docSection")
      if (!digioStatus) {
        getKidData()
      } else {
        setDigiFlow(true);
        setManualDoc(false)
      }
      localStorage.setItem("manualUpload", false)

    } else {
      localStorage.removeItem("docSection")
      localStorage.setItem("manualUpload", true)
      setManualDoc(true);
      setDigiFlow(false);
    }
  };

  const getKidData = async () => {
    try {
      const getKid = await axios.get(Partner_Portal.GetKid_Url, {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${partnerToken}`,
        },
      });
      const kidResponse = decryptData(getKid?.data);
      const decryptedData = JSON.parse(kidResponse);
      if (decryptedData?.status === 0) {
        const kidValue = decryptedData?.data?.info?.access_token?.entity_id;
        const tokenVal = decryptedData?.data?.info?.access_token?.id;
        console.log(kidValue, tokenVal, mobile,"kidValue");

        if (
          (kidValue !== undefined || null || "") &&
          (tokenVal !== undefined || null || "") &&
          (mobile)
          // (mobile !== undefined || null || "")
        ) {
          InitiateDigio(kidValue, mobile, tokenVal);

        } else {
          toast.error(
            "We are facing issue getting required parameters, Please try after sometime"
          );
        }
      } else {
        toast.error(decryptedData?.message);
      }
    } catch (error) {
      console.log(error);
      if (error?.response?.status === 500) {
        toast.error("Your application couldn’t be processed due to a technical issue. Please try again.");
      }
      if (error?.request?.status === 401) {
        localStorage.clear("");
        navigate("/partner");
      }
    }
  };

  const getSignupPartnerDetail = async () => {
    try {
      const getValues = await axios.get(
        Partner_Portal.CreatePartner_Url,

        {
          headers: {
            "Content-Type": "text/plain",
            Authorization: `Bearer ${partnerToken}`,
          },
        }
      );
      const signupResp = decryptData(getValues?.data);
      const decryptedData = JSON.parse(signupResp);
      if (decryptedData?.status === 0) {
        let documentsData = decryptedData?.data?.info;
        setPartnerData(documentsData);
        console.log(documentsData, "documentsData");

        if (documentsData?.isDigilocker === true) {
          setDigiVal(true);
          setDigioStatus(true);
          // setDigiFlow(true);
          setManualDoc(false);
          if (docSection !== "true") {   // added new line
            setDigiFlow(true);
          }
        }

        // if (documentsData?.email === null) {
        //   toast.error("Your Previous details are pending. Please complete");
        //   navigate("/partner/basic-details")
        // }
      } else {
        toast.error(decryptedData?.message);
      }
    } catch (error) {
      console.log(error);
      if (error?.response?.status === 500) {
        toast.error("Your application couldn’t be processed due to a technical issue. Please try again.");
      }
      if (error?.request?.status === 401) {
        localStorage.clear("");
        navigate("/partner");
      }
    }
  };

  useEffect(() => {
    getSignupPartnerDetail();
  }, []);

  const handleNavigate = () => {
    navigate("/partner/select-documents");
  };

  const uploadManually = () => {
    if (docList == null && docListManual?.length == null) {
      document.getElementById("checkimage2").style.display = "block";
      document.getElementById("checkimage1").style.display = "none";
    } else {
      document.getElementById("checkimage2").style.display = "block";
    }
    setTimeout(handleNavigate, 200);
  };

  const previousBtn = () => {
    navigate("/partner/basic-details");
  };

  // const fetchKidValue = window.location.href.split("=");
  // const kidNum = fetchKidValue[2];
  // console.log(kidNum, window.location.href, "kidNum");

  const queryParams = new URLSearchParams(window.location.search);

  const status = queryParams.get("status");
  const kidNum = queryParams.get("kid");

  console.log(kidNum, typeof status, "kidNum");

  useEffect(() => {
    if (kidNum?.length > 0 && status === "0" && digiVal !== true) {
      setDigioStatus(true);
    }
  }, [digiVal, status])



  const uploadKIDData = async () => {
    let encryptedPayload = {
      kid: kidNum,
    };
    let encPayloadVal = encryptData(JSON.stringify(encryptedPayload));
    try {
      const postKidData = await axios.post(
        Partner_Portal.GetKid_Url,
        encPayloadVal,

        {
          headers: {
            "Content-Type": "text/plain",
            Authorization: `Bearer ${partnerToken}`,
          },
        }
      );
      const kidResp = decryptData(postKidData?.data);
      const decryptedKid = JSON.parse(kidResp);
      console.log(decryptedKid, "decryptedKid");

      if (decryptedKid?.status === 0) {
        setDigiFlow(true);
      } else {
        setDigiFlow(false);
        setManualDoc(false);
        toast.error(decryptedKid?.message);
      }
    } catch (error) {
      console.log(error);
      if (error?.response?.status === 500) {
        toast.error("Your application couldn’t be processed due to a technical issue. Please try again.");
      }
      if (error?.request?.status === 401) {
        localStorage.clear("");
        navigate("/partner");
      }
    }
  };

  useEffect(() => {
    if (kidNum?.length > 0 && localStorage.getItem("manualUpload") === "false") {
      uploadKIDData();
    }
  }, []);

  useEffect(() => {
    if (localStorage.getItem("manualUpload") === "true" || incompletePan === "true") {
      setManualDoc(true);
      setAddressSection(false);
    }
    if (localStorage.getItem("addressSection") === "true" || incompleteAddress === "true") {
      setAddressSection(true);
      setManualDoc(false);
    }
  }, []);

  console.log(digiFlow, manualDoc, addressSection,
    incompletePan, incompleteAddress, docSection, digioStatus, "incompletePan");


  return (
    <>
      <HeaderPartner />
      <PageProgressBarPartner progress="document-upload" partnerData={partnerData}/>

      <main className="main-content page-wrapper partner-page partner-page-postlogin">
        <div className="h-md-100 ">
          <Row className="h-md-100 p-0 m-0 mobile-view">
            <Col lg={6} className="p-0">
              <PageSideBar />
            </Col>
            <Col lg={6} className="p-0">
              {(((digiFlow === false && manualDoc === false && addressSection === false) &&
                (incompletePan !== "true" && incompleteAddress !== "true")) || docSection === "true") &&

                <div className="page-header right-box">
                  <div className="wrap-all">

                    <div className="page-left landing-page viewheight">
                      <img
                        alt="arrow-img"
                        className="previous-btn"
                        src={previosPageArrow}
                        href="previous page btn"
                        onClick={previousBtn}
                      />
                      <div>
                        <h2 className="page-title">
                          Good Going! We need some documents for KYC
                        </h2>
                        <h3 className="page-subtitle partner-subtitle">
                          Your documents will be included in our partnership
                          agreement
                        </h3>
                      </div>
                    </div>

                    <div className="document-upload-content">
                      <div className="doc-main-content">
                        <div className="upload-docs">
                          {digioStatus === true ?
                            <div className="digilocker-wrapper">
                              <div
                                className="upload-docs__card uploadDG"
                                onClick={() => handleDocList("digilocker")}
                              >
                                <img
                                  src={checkIcon}
                                  alt="check icon"
                                  className="check-img"
                                  id="checkimage1"
                                />

                                <img
                                  className="upload-docs__card__img"
                                  src={Digilocker}
                                  alt="upload with digilocker"
                                />

                                <div className="d-flex flex-column align-items-sm-center">
                                  <p className="upload-docs__card__title digi-text">
                                    Upload using{" "}
                                    <p className="digilocker-text">Digilocker</p>
                                  </p>
                                  <p className="upload-docs__card__time">
                                    <img
                                      className="new-icon-clock"
                                      src={clock}
                                      alt="upload with digilocker"
                                    />
                                  </p>
                                </div>
                              </div>
                              <div className="document-suggest">
                                <p className="suggestion-msg">
                                  <img src={UpHand} alt="left hand icon" />
                                  <span>Recommended</span>
                                </p>
                              </div>
                            </div>
                            :
                            <>
                              <div className="digilocker-wrapper">
                                <div
                                  className="upload-docs__card uploadDG"
                                  onClick={() => handleDocList("digilocker")}
                                >
                                  <img
                                    src={checkIcon}
                                    alt="check icon"
                                    className="check-img"
                                    id="checkimage1"
                                  />

                                  <img
                                    className="upload-docs__card__img"
                                    src={Digilocker}
                                    alt="upload with digilocker"
                                  />

                                  <div className="d-flex flex-column align-items-sm-center">
                                    <p className="upload-docs__card__title digi-text">
                                      Upload using{" "}
                                      <p className="digilocker-text">Digilocker</p>
                                    </p>
                                    <p className="upload-docs__card__time">
                                      <img
                                        className="new-icon-clock"
                                        src={clock}
                                        alt="upload with digilocker"
                                      />
                                    </p>
                                  </div>
                                </div>
                                <div className="document-suggest">
                                  <p className="suggestion-msg">
                                    <img src={UpHand} alt="left hand icon" />
                                    <span>Recommended</span>
                                  </p>
                                </div>
                              </div>

                              <form className="upload-docs__card-left">
                                <div
                                  className="upload-docs__card uploadDG manual-card"
                                  onClick={() => handleDocList("manual")}
                                >
                                  <img
                                    src={checkIcon}
                                    alt="check icon"
                                    className="check-img"
                                    id="checkimage2"
                                  />

                                  <img
                                    className="upload-docs__card__img manual-img"
                                    src={DocumentMenually}
                                    alt="upload with digilocker"
                                  />
                                  <div className="d-flex flex-column align-items-sm-center">
                                    <p className="upload-docs__card__title myself">
                                      Upload documents <p className="manual-text">manually</p>
                                    </p>

                                    <div className="manual-opt">
                                      <img
                                        className="new-icon-clock"
                                        src={manualClock}
                                        alt="upload without digilocker"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </form>
                            </>

                          }

                          {docList !== null && docListManual?.length !== null ?
                            <div className="center-text">
                              <p className="suggestion-msg">
                                <img src={UpHand} alt="left hand icon" />
                                <span>Recommended</span>
                              </p>
                            </div>
                            : ""}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="wrap-footerData">
                    <div className="bank-detail-secure">
                      <img
                        src={sheild}
                        alt=""
                        className="bank-detail-secure-img"
                      />
                      <p className="bank-detail-secure-txt">
                        Your information is safe and secure with us
                      </p>
                    </div>
                    <FormFooterPartner />
                  </div>
                </div>
              }

              {((digiFlow || manualDoc || incompletePan === "true" || incompleteAddress === "true" || addressSection)
                && (docSection !== "true")) &&
                <DigiDocumentList
                  setManualDoc={setManualDoc}
                  manualDoc={manualDoc}
                  digiFlow={digiFlow}
                  setDigiFlow={setDigiFlow}
                  addressSection={addressSection}
                  setAddressSection={setAddressSection}
                />
              }
            </Col>
          </Row>
        </div>
      </main>
    </>
  );
};
export default DocumentsUploadPartner;
